/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';

import './cyber-security-training.less';
import './cyber-security-training.mobile.less';
import './cyber-security-training.en.less';

import './landing/landing-course-section.less';
import './landing/landing-course-section.moblie.less';

import PageLayout from './layout';

import { useStore } from './store';
import LandingCourseSection from './landing/landing-course-section';
import OrgSection from './landing/organization-section';
import ResourcesSection from './landing/resources-section';
import AboutSection from './landing/about-section';
import IntroducingSection from './landing/introducing-section';
import HeaderSection from './landing/header-section';
import { CheckboxValueType } from 'antd/lib/checkbox/Group';
import NavSection from './landing/nav-section';
import { CIVIL_COURSE_TYPES } from './constants';

interface ICyberSecurityTrainingProps {}

const CyberSecurityTraining: React.FunctionComponent<
  ICyberSecurityTrainingProps
> = (props) => {
  const [checkedList, setCheckedList] = React.useState<string[]>([]);

  const handleCheckedListChange = React.useCallback(
    (list: CheckboxValueType[]) => {
      const stringList = list.map((value) => String(value));
      setCheckedList(stringList);
    },
    []
  );

  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    console.log('Checked List:', checkedList);
  }, [checkedList]);
  const scollToCourseRef =
    React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const scollToCybersecRef =
    React.useRef() as React.MutableRefObject<HTMLDivElement>;
  const scollToIntroRef =
    React.useRef() as React.MutableRefObject<HTMLDivElement>;

  const { initPageSettings, page } = useStore();
  const gotoIntro = () => {
    if (scollToIntroRef && scollToIntroRef.current) {
      const divHTML = scollToIntroRef?.current as HTMLDivElement;
      divHTML?.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const gotoAbout = () => {
    if (scollToCybersecRef && scollToCybersecRef.current) {
      const divHTML = scollToCybersecRef?.current as HTMLDivElement;
      divHTML?.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const gotoCourse = () => {
    if (scollToCourseRef && scollToCourseRef.current) {
      const divHTML = scollToCourseRef?.current as HTMLDivElement;
      divHTML?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scollTo = (sectionName: string) => {
    switch (sectionName) {
      case 'intro':
        gotoIntro();
        break;
      case 'about':
        gotoAbout();
        break;
      case 'course':
        gotoCourse();
        break;
      default:
        break;
    }
  };

  const [playFlag, setPlayFlag] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => {
      const scrollTop = document.querySelector('html')?.scrollTop || 0;
      const h =
        document.querySelector<HTMLElement>('.branding-section-container')
          ?.offsetHeight || 0;
      if (scrollTop >= h - window.innerHeight / 2) {
        setPlayFlag(true);
      }
    };
    if (!playFlag) {
      document.addEventListener('scroll', onScroll, { passive: true });
    }
    return () => window.removeEventListener('scroll', onScroll);
  });
  initPageSettings();
  if (!page) {
    return <div>Loading...</div>;
  }

  const { landing: settings } = page;

  return (
    <div>
      <PageLayout pageName="landing-page" noHeader={true}>
        <HeaderSection
          settings={settings}
          scrollTo={scollTo}
          onCheckedListChange={handleCheckedListChange}
        />
        <IntroducingSection
          scrollRef={scollToIntroRef}
          playFlag={playFlag}
          settings={settings}
        />
        <div ref={scollToCourseRef} className="course-section-container">
          <div
            className="course-section-header"
            dangerouslySetInnerHTML={{
              __html: settings?.courseSectionTitle,
            }}
          />
          <div className="course-section-body">
            <NavSection
              settings={settings}
              onCheckedListChange={handleCheckedListChange}
            />
            <div className="course-section-body-right">
              {settings?.courseSections &&
                settings.courseSections
                  .filter(
                    (courseSection: any) =>
                      courseSection.page === 'general-staff' &&
                      CIVIL_COURSE_TYPES.includes(courseSection.page)
                  )
                  .map((courseSection: any, idx: number) => (
                    <LandingCourseSection
                      key={idx}
                      courseSection={courseSection}
                      settings={settings}
                    />
                  ))}
              {settings?.courseSections &&
                settings.courseSections
                  .filter(
                    (itm: any) =>
                      checkedList.includes(itm.filterName) &&
                      !itm.hide &&
                      CIVIL_COURSE_TYPES.includes(itm.page)
                  )
                  .map((courseSection: any, idx: number) => (
                    <LandingCourseSection
                      key={idx}
                      courseSection={courseSection}
                      settings={settings}
                    />
                  ))}
            </div>
          </div>
        </div>
        <AboutSection settings={settings} scrollRef={scollToCybersecRef} />
        <ResourcesSection settings={settings} />
        {/*{process.env.REACT_APP_DOMAIN === 'HKIRC' ? (*/}
        {/*  <OrgSection settings={settings} />*/}
        {/*) : null}*/}
      </PageLayout>
    </div>
  );
};

export default CyberSecurityTraining;
